// src/components/Search/DiscoverDisplay.js

import React from 'react';
import PropTypes from 'prop-types';
import CategoryCarousel from './CategoryCarousel';

export default function DiscoverDisplay({
  discoverResults,
  onItemClick,
  favorites,
  onAddFavorite,
  onRemoveFavorite
}) {
  if (!discoverResults || Object.keys(discoverResults).length === 0) {
    return null;
  }

  return (
    <div className="w-full max-w-7xl px-4 py-8 space-y-16">
      {Object.keys(discoverResults).map((category) => (
        <CategoryCarousel
          key={category}
          category={category}
          items={discoverResults[category]}
          onItemClick={onItemClick}
          favorites={favorites}
          onAddFavorite={onAddFavorite}
          onRemoveFavorite={onRemoveFavorite}
        />
      ))}
    </div>
  );
}

DiscoverDisplay.propTypes = {
  discoverResults: PropTypes.object.isRequired,
  onItemClick: PropTypes.func.isRequired,
  favorites: PropTypes.array.isRequired,
  onAddFavorite: PropTypes.func.isRequired,
  onRemoveFavorite: PropTypes.func.isRequired,
};
